enum AddressUses {
	None,
	Household = 1,
	Business = Household << 1,
	OnStreet = Business << 1,
	OffStreet = OnStreet << 1,
	All = 2147483647
}

export default AddressUses;
